







import VueOptions from '@utils/VueOptions'

settings =
  name: "ProgressBar"

  vue:
    props: ['progress', 'total']

    computed:
      barProgressStyle: ->
        return '0%' unless @progress and @total
        { width: ((@progress * 100) / @total)  + '%' }

export default VueOptions.vue settings
